import { render, staticRenderFns } from "./LanguageFlag.vue?vue&type=template&id=532e8a00&"
import script from "./LanguageFlag.vue?vue&type=script&lang=js&"
export * from "./LanguageFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports